import React, { useEffect, useMemo, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
Chart.register(...registerables)
const options = {
  indexAxis: 'y',
  responsive: true,
  aspectRatio: 1,
  maintainAspectRatio: false,

  plugins: {
    datalabels: {
      display: true,
      formatter: function (value, ctx) {
        return [ctx.chart.data.datasets[ctx.datasetIndex].ldata[ctx.dataIndex]] + ' €'
      },
      color: 'white',
    },
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        color: 'rgba(255,255,255,0.78)',
        usePointStyle: true,
      },
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.label + ': ' + tooltipItem.dataset.ldata[tooltipItem.dataIndex] + ' €'
        },
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: {
        color: 'rgba(255,255,255,0.75)',
        callback: function (e) {
          return e + '%'
        },
      },
    },
    y: {
      stacked: true,
      grid: { color: 'rgba(255,255,255,0.06)' },
      ticks: {
        color: 'rgba(255,255,255,0.75)',
      },
    },
  },
}

const customBarColorPlugin = {
  id: 'customBarColorPlugin',
  beforeDatasetDraw(chart, args, options) {
    const {
      ctx,
      chartArea: { top, bottom },
      scales: { x, y },
    } = chart
    const dataset = chart.data.datasets[args.index]
    if (dataset.label === 'En cours') {
      dataset.ldata.forEach((value, index) => {
        if (value > dataset.ldata3[index]) {
          const meta = chart.getDatasetMeta(args.index)
          const bar = meta.data[index]

          if (bar) {
            bar.options.backgroundColor = 'red'
          }
        }
      })
    }
  },
}

export default function Chart2({ chartData }) {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [labels, setLabels] = useState([])
  const [cdata, setcdata] = useState([])
  const [cdata2, setcdata2] = useState([])
  const [lcdata, setlcdata] = useState([])
  const [lcdata2, setlcdata2] = useState([])
  const [lcdata3, setlcdata3] = useState([])
  useEffect(() => {
    let labls = []
    let dd = []
    let dd2 = []
    let dd3 = []
    if (chartData) {
      chartData.forEach((e) => {
        labls.push(e.classification)
        // dd.push(e.reste)
        dd.push(e.encours > e.cible_a ? 0 : e.reste)
        dd2.push(e.encours)
        dd3.push(e.cible_a)
      })

      setLabels(labls)
      let ndd = []
      let ndd2 = []
      dd.forEach((e, index) => {
        let v1 = dd[index]
        let v2 = dd2[index]
        ndd.push(((v1 / (v1 + v2)) * 100).toFixed(2))
        ndd2.push(((v2 / (v1 + v2)) * 100).toFixed(2))
      })

      setcdata(ndd)
      setcdata2(ndd2)
      setlcdata(dd)
      setlcdata2(dd2)
      setlcdata3(dd3)
    }
  }, [chartData])
  // LAP-733 (GE022) — re-render dataset labels on locale change
  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: t('finance.monBudget.chartAvailable'),
          data: cdata,
          ldata: lcdata,

          backgroundColor: ['#5aa1d8'],
          borderColor: ['#5aa1d8'],
          barThickness: 20,
        },
        {
          label: t('finance.monBudget.chartConsumed'),
          data: cdata2,
          ldata: lcdata2,
          ldata3: lcdata3,
          backgroundColor: ['#ef7d56'],
          borderColor: ['#ef7d56'],
          barThickness: 20,
        },
      ],
    }),
    [labels, cdata, cdata2, lcdata, lcdata2, lcdata3, t, i18n.language],
  )
  // Chart.register(customBarColorPlugin)
  return (
    <Box height={350} position={'relative'} width={'100%'}>
      <Bar data={data} options={options} plugins={[customBarColorPlugin]} />
    </Box>
  )
}
